import { useLazyQuery, useMutation } from "@apollo/client";
import React, { useState } from "react";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";
import { useMyOrgInfo } from "../../../../Layout/AppMain/LoginStatusContext";
import { UPDATE_REGULATION } from "../../../../queries";

const DropdownIsHold = ({ regulationId, refetch }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownToggle = () => {
    setDropdownOpen(!dropdownOpen);
  };
  const { id } = useMyOrgInfo();

  const [editRegulationMutate, { data }] = useMutation(UPDATE_REGULATION, {
    onCompleted() {
      refetch();
    },
  });

  const editRegulation = async (is_hold = false) => {
    await editRegulationMutate({
      variables: {
        orgId: id,
        regulationId: regulationId,
        is_hold: is_hold,
      },
    });
  };

  return (
    <>
      <Dropdown isOpen={dropdownOpen} toggle={dropdownToggle}>
        <DropdownToggle
          caret
          style={{
            background: "#fff",
            color: "#495057",
            borderColor: "#ced4da",
          }}
        >
          選択
        </DropdownToggle>
        <DropdownMenu>
          <DropdownItem
            onClick={() => {
              editRegulation(false);
            }}
          >
            無し
          </DropdownItem>
          <DropdownItem
            onClick={() => {
              editRegulation(true);
            }}
          >
            有り
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </>
  );
};

export default DropdownIsHold;
